import request from "@/utils/request";

export function getMuseums(cityId) {
  const params = {
    cityId: cityId,
  };
  return request({
    url: `/api/Museums/GetMuseums/${cityId}`,
    method: `get`,
    params,
  });
}

export function getMuseumId(id, params) {
  return request({
    url: `/api/Museums/GetMuseum/${id}`,
    method: `get`,
    params,
  });
}

export function postMuseum(data, params) {
  const rec = data.recommendations
    ? data.recommendations.map((el) => (el.id ? el.id : el))
    : [];
  data.recommendations = rec;
  data.cityId = params.cityId;
  return request({
    url: `/api/Museums/CreateMuseum/${data.cityId}`,
    method: `post`,
    data,
  });
}

export function putMuseum(id, data, params) {
  const rec = data.recommendations.length
    ? data.recommendations.map((el) => (el.id ? el.id : el))
    : [];
  data.recommendations = rec;
  data.cityId = params.cityId;
  return request({
    url: `/api/Museums/UpdateMuseum/${id}`,
    method: `put`,
    params,
    data,
  });
}

export function deleteMuseum(id, params) {
  return request({
    url: `/api/Museums/DeleteMuseum/${id}`,
    method: "delete",
    params,
  });
}
